const appConfig = Object.freeze({
  apiUrl: process.env.REACT_APP_API_URL,
  clientUrl: process.env.REACT_APP_CLIENT_URL,
});

export default appConfig;
